// Update your App.tsx to include the new routes
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import LearnPrayer from './pages/LearnPrayer';
import DuaDhikr from './pages/DuaDhikr';
import Quran from './pages/Quran';
import MyMood from './pages/MyMood';
import Prophets from './pages/Prophets';
import About from './pages/About';
import ArticlesLibrary from './pages/ArticlesLibrary';
import EnglishQuranReader from './pages/EnglishQuranReader';
import Donate from './pages/Donate';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ScrollToTop from './components/ScrollToTop';
import WuduGuide from './pages/WuduGuide';
import './App.css';

function App() {
  const [theme, setTheme] = useState<'noor' | 'sukoon'>('noor');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as 'noor' | 'sukoon';
    if (savedTheme) {
      setTheme(savedTheme);
    }
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'noor' ? 'sukoon' : 'noor');
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header theme={theme} toggleTheme={toggleTheme} />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/learn-prayer" element={<LearnPrayer />} />
            <Route path="/wudu-guide" element={<WuduGuide />} />
            <Route path="/dua-dhikr" element={<DuaDhikr />} />
            <Route path="/quran" element={<Quran />} />
            <Route path="/my-mood" element={<MyMood />} />
            <Route path="/prophets" element={<Prophets />} />
            <Route path="/about" element={<About />} />
            <Route path="/articles" element={<ArticlesLibrary />} />
            <Route path="/english-quran" element={<EnglishQuranReader />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;